// Reference:: https://material-ui.com/customization/default-theme/
const Typography = {
  fontFamily: "Poppins",
  h1: {
    fontWeight: 700,
    fontSize: 50,
    lineHeight: "60px",
  },
  h2: {
    fontWeight: 700,
    fontSize: 40,
    lineHeight: "40px",
  },
  h3: {
    fontWeight: 700,
    fontSize: 30,
    lineHeight: "30px",
  },
  h4: {
    fontWeight: 700,
    fontSize: 25,
    lineHeight: "30px",
  },
  h5: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: "30px",
  },
  h6: {
    fontWeight: 700,
    fontSize: 16,
    lineHeight: "25px",
  },
  body1: {
    fontWeight: 500,
    fontSize: 14,
    lineHeight: "20px",
  },
  body2: {
    fontWeight: 500,
    fontSize: 12,
    lineHeight: "20px",
  },
  caption: {
    fontWeight: 600,
    fontSize: 10,
    lineHeight: "20px",
  },
  subtitle1: {
    fontWeight: 700,
    fontSize: 12,
    lineHeight: "20px",
  },
  subtitle2: {
    fontWeight: 600,
    fontSize: 12,
    lineHeight: "20px",
  },
};

export default Typography;
